export default __webpack_public_path__ + "static/header.individual-0d7ba341e653812895fda7274df1d1eb.jpg";